import { render, staticRenderFns } from "./NotifyGroup.vue?vue&type=template&id=1f0a5667&"
import script from "./NotifyGroup.vue?vue&type=script&lang=js&"
export * from "./NotifyGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports